import { render, staticRenderFns } from "./ProductImagesDropdown.vue?vue&type=template&id=77488d4c&scoped=true"
import script from "./ProductImagesDropdown.vue?vue&type=script&lang=js"
export * from "./ProductImagesDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductImagesDropdown.vue?vue&type=style&index=0&id=77488d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77488d4c",
  null
  
)

export default component.exports